<script>
import AddWidgetPopup from './AddWidgetPopup';

export default {
  name: 'EditWidgetPopup',
  extends: AddWidgetPopup,
  emits: ['widgetCtrl', 'close'],
  props: {
    // 등록 & 수정 flag
    mode: {
      type: String,
      default: 'modify'
    },
    // 저장된 위젯 설정 정보
    config: {
      type: Object
    }
  },
  created() {
    this.widgetModify(this.config);
  },
  methods: {
    // 위젯 설정정보 셋팅
    widgetModify(config) {
      if (config?.chartAttr?.widget?.options?.objectType === '') {
        config.chartAttr.widget.options.objectType = null;
      }
      this.orgConfig = config;
      let widgetType = this.config.chartAttr.widget.type;
      this.configItems.length = 0;
      this.configItems.push(config);
      this.widgetConfigName = widgetType + 'Config';
      this.widgetName = widgetType;
    },

    // 위젯 설정 정보 수정
    doAction() {
      if (!this.$refs.config.validate()) {
        return;
      }

      this.configItems.forEach((config) => {
        config.chartAttr.w = this.orgConfig.chartAttr.w;
        config.chartAttr.h = this.orgConfig.chartAttr.h;
        let ctrlObj = { type: 'modified', config: config };
        this.$emit('widgetCtrl', ctrlObj);
      });
      this.configItems = [];
      this.$emit('close');
    }
  }
};
</script>
<style lang="scss" scoped>
@import '@/assets/scpm.scss';
@import './configs/styles/addWidgetPopup.scss';
</style>
